import { formatDate } from '../formatDate/formatDate';
import { formatTime } from '../formatTime/formatTime';

export const formatDateTime = (publishDate: Date): string => {
  const date = formatDate(publishDate).replaceAll('.', '/');
  const time = formatTime(publishDate);

  return `${date} ${time}`;
};
